// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import axios from "axios";
// import { useAuth } from "@/context/AuthContext";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   Tag,
//   ChevronDown,
//   ChevronUp,
//   Package,
//   IndianRupee,
//   RefreshCw,
//   Search,
//   X,
//   AlertTriangle,
//   Layers,
//   Plus,
//   Minus,
//   Save,
//   Edit3,
//   Hash,
//   ChevronLeft,
//   ChevronRight,
//   ChevronsLeft,
//   ChevronsRight,
// } from "lucide-react";
// import { toast } from "sonner";

// const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
// const GST_RATES = [0, 5, 12, 18, 28];

// // ── GST Rate Pill ─────────────────────────────────────────────
// const GstPill = ({ rate, active, onClick }) => (
//   <button
//     onClick={() => onClick(rate)}
//     className={`w-9 h-7 rounded-lg text-[11px] font-black transition-all border ${
//       active
//         ? "bg-emerald-500 text-white border-emerald-400 shadow-sm shadow-emerald-900/30"
//         : "bg-white/5 text-stone-500 border-white/10 hover:border-white/25 hover:text-stone-300"
//     }`}
//   >
//     {rate}%
//   </button>
// );

// // ── Pagination Component (mirrors Inventory exactly) ──────────
// const Pagination = ({
//   currentPage,
//   totalPages,
//   totalItems,
//   itemsPerPage,
//   onPageChange,
//   onPerPageChange,
// }) => {
//   const startIndex = (currentPage - 1) * itemsPerPage;

//   const pageNumbers = useMemo(() => {
//     const maxVisible = 5;
//     let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
//     let end = Math.min(totalPages, start + maxVisible - 1);
//     if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
//     const pages = [];
//     for (let i = start; i <= end; i++) pages.push(i);
//     return pages;
//   }, [currentPage, totalPages]);

//   if (totalPages <= 1) return null;

//   return (
//     <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 pt-4 border-t border-stone-700/50">
//       <div className="flex items-center gap-3">
//         <span className="text-xs text-stone-500">
//           Showing {startIndex + 1}–
//           {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
//           categories
//         </span>
//         <select
//           value={itemsPerPage}
//           onChange={(e) => onPerPageChange(Number(e.target.value))}
//           className="h-8 px-2 rounded-lg border border-white/10 bg-white/5 text-stone-300 text-xs font-medium outline-none focus:ring-2 focus:ring-amber-500/30"
//         >
//           {[500, 1000, 2000, 5000].map((n) => (
//             <option key={n} value={n} className="bg-[#1c1c2e]">
//               {n} per page
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="flex items-center gap-1.5">
//         <button
//           onClick={() => onPageChange(1)}
//           disabled={currentPage === 1}
//           className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
//         >
//           <ChevronsLeft size={14} />
//         </button>
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
//         >
//           <ChevronLeft size={14} />
//         </button>

//         {pageNumbers.map((page) => (
//           <button
//             key={page}
//             onClick={() => onPageChange(page)}
//             className={`min-w-[32px] h-8 rounded-lg text-sm font-medium transition-all ${
//               currentPage === page
//                 ? "bg-amber-500 text-white shadow-sm"
//                 : "bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400"
//             }`}
//           >
//             {page}
//           </button>
//         ))}

//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
//         >
//           <ChevronRight size={14} />
//         </button>
//         <button
//           onClick={() => onPageChange(totalPages)}
//           disabled={currentPage === totalPages}
//           className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
//         >
//           <ChevronsRight size={14} />
//         </button>
//       </div>
//     </div>
//   );
// };

// // ── Category Card ─────────────────────────────────────────────
// const CategoryCard = ({
//   category,
//   products,
//   onGstChange,
//   onProductQtyChange,
//   index,
// }) => {
//   const [expanded, setExpanded] = useState(false);
//   const [editingGst, setEditingGst] = useState(false);
//   const [pendingGst, setPendingGst] = useState(null);
//   const [saving, setSaving] = useState(false);

//   // Product-level search inside expanded card
//   const [prodSearch, setProdSearch] = useState("");

//   // Product pagination inside expanded card
//   const [prodPage, setProdPage] = useState(1);
//   const PROD_PAGE_SIZE = 5;

//   const dominantGst = useMemo(() => {
//     const freq = {};
//     products.forEach((p) => {
//       const r = p.gst_rate ?? 18;
//       freq[r] = (freq[r] || 0) + 1;
//     });
//     return parseInt(
//       Object.entries(freq).sort((a, b) => b[1] - a[1])[0]?.[0] ?? "18",
//     );
//   }, [products]);

//   const displayGst = pendingGst !== null ? pendingGst : dominantGst;

//   const stats = useMemo(
//     () => ({
//       totalStock: products.reduce((s, p) => s + p.stock_quantity, 0),
//       totalValue: products.reduce(
//         (s, p) => s + p.selling_price * p.stock_quantity,
//         0,
//       ),
//       lowStock: products.filter(
//         (p) =>
//           p.stock_quantity > 0 && p.stock_quantity <= p.low_stock_threshold,
//       ).length,
//       outOfStock: products.filter((p) => p.stock_quantity === 0).length,
//     }),
//     [products],
//   );

//   const gstTotal = useMemo(
//     () =>
//       products.reduce((s, p) => {
//         const r = p.gst_rate ?? dominantGst;
//         return (
//           s +
//           (p.selling_price - p.selling_price / (1 + r / 100)) * p.stock_quantity
//         );
//       }, 0),
//     [products, dominantGst],
//   );

//   const filteredProds = useMemo(() => {
//     if (!prodSearch) return products;
//     const q = prodSearch.toLowerCase();
//     return products.filter(
//       (p) =>
//         p.name.toLowerCase().includes(q) || p.sku?.toLowerCase().includes(q),
//     );
//   }, [products, prodSearch]);

//   const totalProdPages = Math.ceil(filteredProds.length / PROD_PAGE_SIZE);
//   const pagedProds = filteredProds.slice(
//     (prodPage - 1) * PROD_PAGE_SIZE,
//     prodPage * PROD_PAGE_SIZE,
//   );

//   const handleGstSave = async () => {
//     if (pendingGst === null) {
//       setEditingGst(false);
//       return;
//     }
//     setSaving(true);
//     try {
//       await onGstChange(category, products, pendingGst);
//       toast.success(
//         `GST updated to ${pendingGst}% for all "${category}" products`,
//       );
//       setEditingGst(false);
//       setPendingGst(null);
//     } catch {
//       toast.error("Failed to update GST");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 12 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{
//         delay: index * 0.035,
//         type: "spring",
//         stiffness: 300,
//         damping: 28,
//       }}
//       className="bg-[#1c1c2e] border border-white/10 rounded-2xl overflow-hidden shadow-lg"
//     >
//       {/* ── Header ── */}
//       <div
//         className="px-5 py-4 cursor-pointer select-none"
//         onClick={() => setExpanded((v) => !v)}
//       >
//         <div className="flex items-start justify-between gap-4">
//           {/* Left */}
//           <div className="flex items-center gap-3 min-w-0">
//             <div className="p-2.5 bg-amber-500/15 rounded-xl border border-amber-500/20 flex-shrink-0">
//               <Tag size={16} className="text-amber-400" />
//             </div>
//             <div className="min-w-0">
//               <h3 className="font-black text-white text-base capitalize truncate">
//                 {category}
//               </h3>
//               <div className="flex items-center gap-3 mt-0.5 flex-wrap">
//                 <span className="text-[11px] text-stone-500 flex items-center gap-1">
//                   <Package size={10} /> {products.length} product
//                   {products.length !== 1 ? "s" : ""}
//                 </span>
//                 <span className="text-[11px] text-stone-500 flex items-center gap-1">
//                   <Hash size={10} /> {stats.totalStock} units
//                 </span>
//                 <span className="text-[11px] text-emerald-400 font-semibold flex items-center gap-1">
//                   <IndianRupee size={10} />₹
//                   {stats.totalValue.toLocaleString("en-IN", {
//                     maximumFractionDigits: 0,
//                   })}{" "}
//                   value
//                 </span>
//                 {stats.lowStock > 0 && (
//                   <span className="text-[11px] text-amber-400 flex items-center gap-1">
//                     <AlertTriangle size={10} /> {stats.lowStock} low
//                   </span>
//                 )}
//                 {stats.outOfStock > 0 && (
//                   <span className="text-[11px] text-rose-400 flex items-center gap-1">
//                     <X size={10} /> {stats.outOfStock} out
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Right: GST badge */}
//           <div className="flex items-center gap-2 flex-shrink-0">
//             <div
//               className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-3 py-2"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="text-right">
//                 <p className="text-[9px] text-stone-500 font-bold uppercase tracking-wider">
//                   GST Rate
//                 </p>
//                 <p className="text-emerald-400 font-black text-sm">
//                   {displayGst}%
//                 </p>
//               </div>
//               <div className="w-px h-8 bg-white/10" />
//               <div className="text-right">
//                 <p className="text-[9px] text-stone-500 font-bold uppercase tracking-wider">
//                   GST Value
//                 </p>
//                 <p className="text-stone-300 font-black text-sm">
//                   ₹
//                   {gstTotal.toLocaleString("en-IN", {
//                     maximumFractionDigits: 0,
//                   })}
//                 </p>
//               </div>
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setEditingGst((v) => !v);
//                   if (editingGst) setPendingGst(null);
//                 }}
//                 className="ml-1 p-1.5 rounded-lg hover:bg-white/10 text-stone-400 hover:text-amber-400 transition-colors"
//                 title="Edit GST rate for this category"
//               >
//                 <Edit3 size={12} />
//               </button>
//             </div>
//             <div className="p-2 text-stone-500">
//               {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
//             </div>
//           </div>
//         </div>

//         {/* GST Editor */}
//         <AnimatePresence>
//           {editingGst && (
//             <motion.div
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: "auto" }}
//               exit={{ opacity: 0, height: 0 }}
//               className="overflow-hidden"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="mt-3 pt-3 border-t border-white/10 flex items-center justify-between gap-3 flex-wrap">
//                 <div className="flex items-center gap-1.5 flex-wrap">
//                   <span className="text-[11px] font-bold text-stone-400 uppercase tracking-wider mr-1">
//                     Apply to all "{category}" products:
//                   </span>
//                   {GST_RATES.map((r) => (
//                     <GstPill
//                       key={r}
//                       rate={r}
//                       active={(pendingGst ?? dominantGst) === r}
//                       onClick={setPendingGst}
//                     />
//                   ))}
//                 </div>
//                 <div className="flex gap-2">
//                   <button
//                     onClick={() => {
//                       setEditingGst(false);
//                       setPendingGst(null);
//                     }}
//                     className="h-8 px-3 rounded-lg border border-white/10 text-stone-400 hover:text-white text-xs font-semibold transition-all"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleGstSave}
//                     disabled={saving || pendingGst === null}
//                     className="h-8 px-4 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-white font-black text-xs flex items-center gap-1.5 transition-all disabled:opacity-40"
//                   >
//                     {saving ? (
//                       <RefreshCw size={11} className="animate-spin" />
//                     ) : (
//                       <Save size={11} />
//                     )}
//                     Apply to {products.length} products
//                   </button>
//                 </div>
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>

//       {/* ── Expanded Product List ── */}
//       <AnimatePresence>
//         {expanded && (
//           <motion.div
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: "auto" }}
//             exit={{ opacity: 0, height: 0 }}
//             transition={{ duration: 0.2 }}
//             className="overflow-hidden"
//           >
//             <div className="border-t border-white/10">
//               {/* Product search */}
//               <div className="px-5 py-3 border-b border-white/5">
//                 <div className="relative">
//                   <Search
//                     size={13}
//                     className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-500"
//                   />
//                   <input
//                     value={prodSearch}
//                     onChange={(e) => {
//                       setProdSearch(e.target.value);
//                       setProdPage(1);
//                     }}
//                     placeholder="Search products in this category…"
//                     className="w-full h-8 bg-white/5 border border-white/10 rounded-lg pl-8 pr-8 text-xs text-stone-300 outline-none focus:ring-1 focus:ring-amber-500/40 placeholder-stone-600 transition-all"
//                   />
//                   {prodSearch && (
//                     <button
//                       onClick={() => {
//                         setProdSearch("");
//                         setProdPage(1);
//                       }}
//                       className="absolute right-2.5 top-1/2 -translate-y-1/2 text-stone-500 hover:text-stone-300"
//                     >
//                       <X size={12} />
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* Product rows */}
//               {pagedProds.length === 0 ? (
//                 <div className="px-5 py-8 text-center text-stone-500 text-sm">
//                   No products match your search
//                 </div>
//               ) : (
//                 <div className="divide-y divide-white/5">
//                   {pagedProds.map((product, pi) => {
//                     const rate = product.gst_rate ?? dominantGst;
//                     const taxable = product.selling_price / (1 + rate / 100);
//                     const gstPerUnit = product.selling_price - taxable;
//                     const isLow =
//                       product.stock_quantity > 0 &&
//                       product.stock_quantity <= product.low_stock_threshold;
//                     const isOut = product.stock_quantity === 0;
//                     return (
//                       <motion.div
//                         key={product.id}
//                         initial={{ opacity: 0, x: -6 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: pi * 0.02 }}
//                         className="flex items-center gap-3 px-5 py-3 hover:bg-white/3 transition-colors group"
//                       >
//                         <img
//                           src={`${process.env.REACT_APP_BACKEND_URL}${product.image_url}`}
//                           alt={product.name}
//                           className="w-10 h-10 object-cover rounded-xl flex-shrink-0 border border-white/10"
//                           onError={(e) => {
//                             e.target.style.display = "none";
//                           }}
//                         />
//                         <div className="flex-1 min-w-0">
//                           <p className="text-sm font-bold text-stone-200 truncate">
//                             {product.name}
//                           </p>
//                           <p className="text-[10px] font-mono text-stone-600 mt-0.5">
//                             {product.sku}
//                           </p>
//                         </div>
//                         <div className="text-right flex-shrink-0 hidden sm:block">
//                           <p className="font-mono font-black text-white text-sm">
//                             ₹{product.selling_price.toFixed(2)}
//                           </p>
//                           <p className="text-[10px] text-stone-500">
//                             taxable ₹{taxable.toFixed(2)}
//                           </p>
//                         </div>
//                         <div className="text-right flex-shrink-0 min-w-[70px] hidden md:block">
//                           <p className="text-[10px] text-stone-500 mb-0.5">
//                             GST/unit
//                           </p>
//                           <p className="font-mono font-bold text-emerald-400 text-sm">
//                             ₹{gstPerUnit.toFixed(2)}
//                           </p>
//                           <p className="text-[10px] text-stone-600">{rate}%</p>
//                         </div>
//                         <div className="flex items-center gap-2 flex-shrink-0">
//                           <span
//                             className={`text-[10px] font-black px-2 py-1 rounded-full border ${
//                               isOut
//                                 ? "bg-rose-500/15 text-rose-400 border-rose-500/20"
//                                 : isLow
//                                   ? "bg-amber-500/15 text-amber-400 border-amber-500/20"
//                                   : "bg-white/8 text-stone-400 border-white/10"
//                             }`}
//                           >
//                             {product.stock_quantity}
//                           </span>
//                           <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
//                             <button
//                               onClick={() => onProductQtyChange(product.id, -1)}
//                               disabled={isOut}
//                               className="w-6 h-6 rounded-lg bg-white/8 hover:bg-rose-500/20 text-stone-400 hover:text-rose-400 flex items-center justify-center transition-colors disabled:opacity-30"
//                             >
//                               <Minus size={10} />
//                             </button>
//                             <button
//                               onClick={() => onProductQtyChange(product.id, 1)}
//                               className="w-6 h-6 rounded-lg bg-white/8 hover:bg-emerald-500/20 text-stone-400 hover:text-emerald-400 flex items-center justify-center transition-colors"
//                             >
//                               <Plus size={10} />
//                             </button>
//                           </div>
//                         </div>
//                       </motion.div>
//                     );
//                   })}
//                 </div>
//               )}

//               {/* Product-level pagination */}
//               {totalProdPages > 1 && (
//                 <div className="px-5 py-3 border-t border-white/5 flex items-center justify-between">
//                   <span className="text-[11px] text-stone-500">
//                     {(prodPage - 1) * PROD_PAGE_SIZE + 1}–
//                     {Math.min(prodPage * PROD_PAGE_SIZE, filteredProds.length)}{" "}
//                     of {filteredProds.length} products
//                   </span>
//                   <div className="flex items-center gap-1">
//                     <button
//                       onClick={() => setProdPage(1)}
//                       disabled={prodPage === 1}
//                       className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
//                     >
//                       <ChevronsLeft size={12} />
//                     </button>
//                     <button
//                       onClick={() => setProdPage((p) => Math.max(1, p - 1))}
//                       disabled={prodPage === 1}
//                       className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
//                     >
//                       <ChevronLeft size={12} />
//                     </button>
//                     {Array.from(
//                       { length: Math.min(5, totalProdPages) },
//                       (_, i) => {
//                         const start = Math.max(
//                           1,
//                           Math.min(prodPage - 2, totalProdPages - 4),
//                         );
//                         const p = start + i;
//                         return (
//                           <button
//                             key={p}
//                             onClick={() => setProdPage(p)}
//                             className={`w-7 h-7 rounded-lg text-xs font-semibold transition-all ${
//                               p === prodPage
//                                 ? "bg-amber-500 text-white"
//                                 : "bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10"
//                             }`}
//                           >
//                             {p}
//                           </button>
//                         );
//                       },
//                     )}
//                     <button
//                       onClick={() =>
//                         setProdPage((p) => Math.min(totalProdPages, p + 1))
//                       }
//                       disabled={prodPage === totalProdPages}
//                       className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
//                     >
//                       <ChevronRight size={12} />
//                     </button>
//                     <button
//                       onClick={() => setProdPage(totalProdPages)}
//                       disabled={prodPage === totalProdPages}
//                       className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
//                     >
//                       <ChevronsRight size={12} />
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* Category GST Summary Footer */}
//               <div className="px-5 py-3 bg-white/3 border-t border-white/10 flex items-center justify-between flex-wrap gap-3">
//                 <div className="flex items-center gap-4 flex-wrap">
//                   {[
//                     {
//                       label: "Taxable Value",
//                       value: `₹${products.reduce((s, p) => s + (p.selling_price / (1 + (p.gst_rate ?? dominantGst) / 100)) * p.stock_quantity, 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`,
//                       color: "text-stone-300",
//                     },
//                     {
//                       label: `GST @ ${displayGst}%`,
//                       value: `₹${gstTotal.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`,
//                       color: "text-emerald-400",
//                     },
//                     {
//                       label: `CGST (${displayGst / 2}%) + SGST (${displayGst / 2}%)`,
//                       value: `₹${(gstTotal / 2).toLocaleString("en-IN", { maximumFractionDigits: 2 })} each`,
//                       color: "text-blue-400",
//                     },
//                   ].map((s) => (
//                     <div key={s.label}>
//                       <p className="text-[9px] text-stone-500 uppercase tracking-wider font-bold">
//                         {s.label}
//                       </p>
//                       <p className={`text-sm font-black ${s.color}`}>
//                         {s.value}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//                 <div>
//                   <p className="text-[9px] text-stone-500 uppercase tracking-wider font-bold">
//                     Total MRP Value
//                   </p>
//                   <p className="text-sm font-black text-amber-400">
//                     ₹
//                     {stats.totalValue.toLocaleString("en-IN", {
//                       maximumFractionDigits: 2,
//                     })}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div>
//   );
// };

// // ═══════════════════════════════════════════════════════════════
// // MAIN PAGE
// // ═══════════════════════════════════════════════════════════════
// const CategoryGST = () => {
//   const { token } = useAuth();

//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [gstFilter, setGstFilter] = useState(null);

//   // ── Category-level pagination (mirrors Inventory) ─────────────
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(1000);

//   const headers = useMemo(
//     () => ({ Authorization: `Bearer ${token}` }),
//     [token],
//   );

//   const fetchProducts = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_URL}/products`, {
//         headers,
//         params: { limit: itemsPerPage },
//       });
//       setProducts(res.data.products || []);
//     } catch {
//       toast.error("Failed to load products");
//     } finally {
//       setLoading(false);
//     }
//   }, [headers]);

//   useEffect(() => {
//     fetchProducts();
//   }, [fetchProducts]);

//   // ── Reset to page 1 when filters change ──────────────────────
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchQuery, gstFilter, itemsPerPage]);

//   // ── Group products by category ────────────────────────────────
//   const grouped = useMemo(() => {
//     const map = {};
//     products.forEach((p) => {
//       const cat = p.category || "Uncategorized";
//       if (!map[cat]) map[cat] = [];
//       map[cat].push(p);
//     });
//     return map;
//   }, [products]);

//   // ── Filter + sort all categories ─────────────────────────────
//   const allFilteredCategories = useMemo(() => {
//     return Object.entries(grouped)
//       .filter(([cat, prods]) => {
//         const matchSearch =
//           !searchQuery ||
//           cat.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           prods.some(
//             (p) =>
//               p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//               p.sku?.toLowerCase().includes(searchQuery.toLowerCase()),
//           );
//         const matchGst =
//           gstFilter === null ||
//           prods.some((p) => (p.gst_rate ?? 18) === gstFilter);
//         return matchSearch && matchGst;
//       })
//       .sort((a, b) => a[0].localeCompare(b[0]));
//   }, [grouped, searchQuery, gstFilter]);

//   // ── Paginate categories ───────────────────────────────────────
//   const totalPages = Math.ceil(allFilteredCategories.length / itemsPerPage);
//   const pagedCategories = allFilteredCategories.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage,
//   );

//   // ── Overall summary ────────────────────────────────────────────
//   const summary = useMemo(() => {
//     const totalGSTValue = products.reduce((s, p) => {
//       const r = p.gst_rate ?? 18;
//       return (
//         s +
//         (p.selling_price - p.selling_price / (1 + r / 100)) * p.stock_quantity
//       );
//     }, 0);
//     const totalMRP = products.reduce(
//       (s, p) => s + p.selling_price * p.stock_quantity,
//       0,
//     );
//     const byRate = {};
//     products.forEach((p) => {
//       const r = p.gst_rate ?? 18;
//       const gst =
//         (p.selling_price - p.selling_price / (1 + r / 100)) * p.stock_quantity;
//       byRate[r] = (byRate[r] || 0) + gst;
//     });
//     return {
//       totalCategories: Object.keys(grouped).length,
//       totalProducts: products.length,
//       totalGSTValue,
//       totalMRP,
//       totalTaxable: totalMRP - totalGSTValue,
//       byRate,
//     };
//   }, [products, grouped]);

//   // ── Handlers ──────────────────────────────────────────────────
//   const handleGstChange = useCallback(
//     async (category, prods, newRate) => {
//       await Promise.all(
//         prods.map((p) =>
//           axios.put(
//             `${API_URL}/products/${p.id}`,
//             { ...p, gst_rate: newRate },
//             { headers },
//           ),
//         ),
//       );
//       setProducts((prev) =>
//         prev.map((p) =>
//           p.category === category ? { ...p, gst_rate: newRate } : p,
//         ),
//       );
//     },
//     [headers],
//   );

//   const handleProductQtyChange = useCallback(
//     async (productId, delta) => {
//       const product = products.find((p) => p.id === productId);
//       if (!product) return;
//       const newQty = Math.max(0, product.stock_quantity + delta);
//       try {
//         await axios.put(
//           `${API_URL}/products/${productId}`,
//           { ...product, stock_quantity: newQty },
//           { headers },
//         );
//         setProducts((prev) =>
//           prev.map((p) =>
//             p.id === productId ? { ...p, stock_quantity: newQty } : p,
//           ),
//         );
//       } catch {
//         toast.error("Failed to update quantity");
//       }
//     },
//     [products, headers],
//   );

//   // ─────────────────────────────────────────────────────────────
//   return (
//     <div
//       className="min-h-full bg-[#f7f6f3] p-4 md:p-6 lg:p-8"
//       data-testid="category-gst-page"
//     >
//       {/* ── Hero Header ── */}
//       <motion.div
//         initial={{ opacity: 0, y: -12 }}
//         animate={{ opacity: 1, y: 0 }}
//         className="relative overflow-hidden bg-[#1c1c2e] rounded-2xl p-6 mb-6 shadow-xl"
//       >
//         <div
//           className="absolute inset-0 opacity-10 pointer-events-none"
//           style={{
//             backgroundImage:
//               "radial-gradient(circle at 80% 40%, #10b981 0%, transparent 50%), radial-gradient(circle at 15% 80%, #f59e0b 0%, transparent 40%)",
//           }}
//         />
//         <div className="relative flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//           <div className="flex items-center gap-4">
//             <div className="p-3 bg-emerald-500/15 rounded-2xl border border-emerald-500/20">
//               <Layers size={24} className="text-emerald-400" />
//             </div>
//             <div>
//               <h1 className="text-2xl md:text-3xl font-black text-white tracking-tight">
//                 Category GST Manager
//               </h1>
//               <p className="text-stone-400 text-sm mt-0.5">
//                 View and bulk-update GST rates by product category
//               </p>
//             </div>
//           </div>
//           <button
//             onClick={fetchProducts}
//             disabled={loading}
//             className="flex items-center gap-2 bg-white/10 hover:bg-white/15 border border-white/15 text-stone-300 hover:text-white font-bold text-sm px-4 py-3 rounded-xl transition-all"
//           >
//             <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
//             Refresh
//           </button>
//         </div>

//         {/* Summary stats */}
//         <div className="relative mt-5 pt-4 border-t border-white/10 grid grid-cols-2 sm:grid-cols-4 gap-4">
//           {[
//             {
//               label: "Categories",
//               value: summary.totalCategories,
//               color: "text-amber-400",
//             },
//             {
//               label: "Total Products",
//               value: summary.totalProducts,
//               color: "text-stone-200",
//             },
//             {
//               label: "Taxable Value",
//               value: `₹${summary.totalTaxable.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
//               color: "text-blue-400",
//             },
//             {
//               label: "Total GST",
//               value: `₹${summary.totalGSTValue.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
//               color: "text-emerald-400",
//             },
//           ].map((s) => (
//             <div key={s.label}>
//               <p className="text-stone-500 text-[10px] uppercase tracking-wider font-semibold mb-0.5">
//                 {s.label}
//               </p>
//               <p className={`font-mono font-black text-lg ${s.color}`}>
//                 {s.value}
//               </p>
//             </div>
//           ))}
//         </div>

//         {/* GST rate filter chips */}
//         {Object.keys(summary.byRate).length > 0 && (
//           <div className="relative mt-4 pt-3 border-t border-white/10 flex flex-wrap gap-2 items-center">
//             <span className="text-[10px] text-stone-500 font-bold uppercase tracking-wider">
//               Filter by rate:
//             </span>
//             {Object.entries(summary.byRate)
//               .sort((a, b) => Number(a[0]) - Number(b[0]))
//               .map(([rate, val]) => (
//                 <button
//                   key={rate}
//                   onClick={() =>
//                     setGstFilter((prev) =>
//                       prev === Number(rate) ? null : Number(rate),
//                     )
//                   }
//                   className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[11px] font-bold border transition-all ${
//                     gstFilter === Number(rate)
//                       ? "bg-emerald-500/20 border-emerald-500/50 text-emerald-300"
//                       : "bg-white/5 border-white/10 text-stone-400 hover:border-white/25 hover:text-stone-200"
//                   }`}
//                 >
//                   <span className="text-emerald-400">{rate}%</span>
//                   <span className="text-stone-600">→</span>
//                   <span>
//                     ₹{val.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
//                   </span>
//                 </button>
//               ))}
//             {gstFilter !== null && (
//               <button
//                 onClick={() => setGstFilter(null)}
//                 className="flex items-center gap-1 px-2.5 py-1.5 rounded-xl text-[11px] font-bold bg-rose-500/15 border border-rose-500/30 text-rose-400 hover:bg-rose-500/25 transition-all"
//               >
//                 <X size={10} /> Clear
//               </button>
//             )}
//           </div>
//         )}
//       </motion.div>

//       {/* ── Search ── */}
//       <motion.div
//         initial={{ opacity: 0, y: 8 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.1 }}
//         className="relative mb-5"
//       >
//         <Search
//           size={15}
//           className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400"
//         />
//         <input
//           type="text"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           placeholder="Search categories or products…"
//           className="w-full h-11 bg-white border border-stone-200 rounded-xl pl-10 pr-4 text-sm text-stone-700 outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-400/50 shadow-sm"
//         />
//         {searchQuery && (
//           <button
//             onClick={() => setSearchQuery("")}
//             className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-600 p-1"
//           >
//             <X size={13} />
//           </button>
//         )}
//       </motion.div>

//       {/* ── Content ── */}
//       {loading ? (
//         <div className="flex items-center justify-center py-24">
//           <div className="text-center">
//             <div className="relative w-14 h-14 mx-auto mb-4">
//               <div className="absolute inset-0 rounded-full border-4 border-emerald-100" />
//               <div className="absolute inset-0 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin" />
//             </div>
//             <p className="text-stone-400 text-sm">Loading categories…</p>
//           </div>
//         </div>
//       ) : allFilteredCategories.length === 0 ? (
//         <div className="flex flex-col items-center justify-center py-24 bg-white rounded-2xl border border-stone-100 shadow-sm">
//           <div className="p-4 bg-stone-100 rounded-2xl mb-4">
//             <Layers size={32} className="text-stone-300" />
//           </div>
//           <p className="text-stone-500 font-semibold">No categories found</p>
//           <p className="text-stone-400 text-sm mt-1">
//             {searchQuery
//               ? "Try adjusting your search"
//               : "Add products to see categories"}
//           </p>
//         </div>
//       ) : (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.15 }}
//         >
//           <div className="space-y-3">
//             {pagedCategories.map(([category, prods], idx) => (
//               <CategoryCard
//                 key={category}
//                 category={category}
//                 products={prods}
//                 onGstChange={handleGstChange}
//                 onProductQtyChange={handleProductQtyChange}
//                 index={idx}
//               />
//             ))}
//           </div>

//           {/* ── Category Pagination (identical logic to Inventory) ── */}
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             totalItems={allFilteredCategories.length}
//             itemsPerPage={itemsPerPage}
//             onPageChange={setCurrentPage}
//             onPerPageChange={(n) => {
//               setItemsPerPage(n);
//               setCurrentPage(1);
//             }}
//           />
//         </motion.div>
//       )}
//     </div>
//   );
// };

// export default CategoryGST;

import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import {
  Tag,
  ChevronDown,
  ChevronUp,
  Package,
  IndianRupee,
  RefreshCw,
  Search,
  X,
  AlertTriangle,
  Layers,
  Plus,
  Minus,
  Save,
  Edit3,
  Hash,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { toast } from "sonner";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GST_RATES = [0, 5, 12, 18, 28];

// ── GST Rate Pill ─────────────────────────────────────────────
const GstPill = ({ rate, active, onClick }) => (
  <button
    onClick={() => onClick(rate)}
    className={`w-9 h-7 rounded-lg text-[11px] font-black transition-all border ${
      active
        ? "bg-emerald-500 text-white border-emerald-400 shadow-sm shadow-emerald-900/30"
        : "bg-white/5 text-stone-500 border-white/10 hover:border-white/25 hover:text-stone-300"
    }`}
  >
    {rate}%
  </button>
);

// ── Pagination Component ──────────────────────────────────────
const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onPerPageChange,
}) => {
  const startIndex = (currentPage - 1) * itemsPerPage;

  const pageNumbers = useMemo(() => {
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }, [currentPage, totalPages]);

  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 pt-4 border-t border-stone-700/50">
      <div className="flex items-center gap-3">
        <span className="text-xs text-stone-500">
          Showing {startIndex + 1}–
          {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
          categories
        </span>
        <select
          value={itemsPerPage}
          onChange={(e) => onPerPageChange(Number(e.target.value))}
          className="h-8 px-2 rounded-lg border border-white/10 bg-white/5 text-stone-300 text-xs font-medium outline-none focus:ring-2 focus:ring-amber-500/30"
        >
          {[10, 25, 50, 100].map((n) => (
            <option key={n} value={n} className="bg-[#1c1c2e]">
              {n} per page
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-1.5">
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <ChevronsLeft size={14} />
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <ChevronLeft size={14} />
        </button>

        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`min-w-[32px] h-8 rounded-lg text-sm font-medium transition-all ${
              currentPage === page
                ? "bg-amber-500 text-white shadow-sm"
                : "bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400"
            }`}
          >
            {page}
          </button>
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <ChevronRight size={14} />
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-stone-400 hover:bg-white/10 hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <ChevronsRight size={14} />
        </button>
      </div>
    </div>
  );
};

// ── Category Card ─────────────────────────────────────────────
const CategoryCard = ({
  category,
  products,
  onGstChange,
  onProductQtyChange,
  index,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [editingGst, setEditingGst] = useState(false);
  const [pendingGst, setPendingGst] = useState(null);
  const [saving, setSaving] = useState(false);

  // Product-level search inside expanded card
  const [prodSearch, setProdSearch] = useState("");

  // Product pagination inside expanded card
  const [prodPage, setProdPage] = useState(1);
  const [prodPageSize, setProdPageSize] = useState(10);

  const dominantGst = useMemo(() => {
    const freq = {};
    products.forEach((p) => {
      const r = p.gst_rate ?? 18;
      freq[r] = (freq[r] || 0) + 1;
    });
    return parseInt(
      Object.entries(freq).sort((a, b) => b[1] - a[1])[0]?.[0] ?? "18",
    );
  }, [products]);

  const displayGst = pendingGst !== null ? pendingGst : dominantGst;

  const stats = useMemo(
    () => ({
      totalStock: products.reduce((s, p) => s + p.stock_quantity, 0),
      totalValue: products.reduce(
        (s, p) => s + p.selling_price * p.stock_quantity,
        0,
      ),
      lowStock: products.filter(
        (p) =>
          p.stock_quantity > 0 && p.stock_quantity <= p.low_stock_threshold,
      ).length,
      outOfStock: products.filter((p) => p.stock_quantity === 0).length,
    }),
    [products],
  );

  const gstTotal = useMemo(
    () =>
      products.reduce((s, p) => {
        const r = p.gst_rate ?? dominantGst;
        return (
          s +
          (p.selling_price - p.selling_price / (1 + r / 100)) * p.stock_quantity
        );
      }, 0),
    [products, dominantGst],
  );

  const filteredProds = useMemo(() => {
    if (!prodSearch) return products;
    const q = prodSearch.toLowerCase();
    return products.filter(
      (p) =>
        p.name.toLowerCase().includes(q) || p.sku?.toLowerCase().includes(q),
    );
  }, [products, prodSearch]);

  const totalProdPages = Math.ceil(filteredProds.length / prodPageSize);
  const pagedProds = filteredProds.slice(
    (prodPage - 1) * prodPageSize,
    prodPage * prodPageSize,
  );

  const handleGstSave = async () => {
    if (pendingGst === null) {
      setEditingGst(false);
      return;
    }
    setSaving(true);
    try {
      await onGstChange(category, products, pendingGst);
      toast.success(
        `GST updated to ${pendingGst}% for all "${category}" products`,
      );
      setEditingGst(false);
      setPendingGst(null);
    } catch {
      toast.error("Failed to update GST");
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        delay: index * 0.035,
        type: "spring",
        stiffness: 300,
        damping: 28,
      }}
      className="bg-[#1c1c2e] border border-white/10 rounded-2xl overflow-hidden shadow-lg"
    >
      {/* ── Header ── */}
      <div
        className="px-5 py-4 cursor-pointer select-none"
        onClick={() => setExpanded((v) => !v)}
      >
        <div className="flex items-start justify-between gap-4">
          {/* Left */}
          <div className="flex items-center gap-3 min-w-0">
            <div className="p-2.5 bg-amber-500/15 rounded-xl border border-amber-500/20 flex-shrink-0">
              <Tag size={16} className="text-amber-400" />
            </div>
            <div className="min-w-0">
              <h3 className="font-black text-white text-base capitalize truncate">
                {category}
              </h3>
              <div className="flex items-center gap-3 mt-0.5 flex-wrap">
                <span className="text-[11px] text-stone-500 flex items-center gap-1">
                  <Package size={10} /> {products.length} product
                  {products.length !== 1 ? "s" : ""}
                </span>
                <span className="text-[11px] text-stone-500 flex items-center gap-1">
                  <Hash size={10} /> {stats.totalStock} units
                </span>
                <span className="text-[11px] text-emerald-400 font-semibold flex items-center gap-1">
                  <IndianRupee size={10} />₹
                  {stats.totalValue.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}{" "}
                  value
                </span>
                {stats.lowStock > 0 && (
                  <span className="text-[11px] text-amber-400 flex items-center gap-1">
                    <AlertTriangle size={10} /> {stats.lowStock} low
                  </span>
                )}
                {stats.outOfStock > 0 && (
                  <span className="text-[11px] text-rose-400 flex items-center gap-1">
                    <X size={10} /> {stats.outOfStock} out
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Right: GST badge */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <div
              className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-3 py-2"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="text-right">
                <p className="text-[9px] text-stone-500 font-bold uppercase tracking-wider">
                  GST Rate
                </p>
                <p className="text-emerald-400 font-black text-sm">
                  {displayGst}%
                </p>
              </div>
              <div className="w-px h-8 bg-white/10" />
              <div className="text-right">
                <p className="text-[9px] text-stone-500 font-bold uppercase tracking-wider">
                  GST Value
                </p>
                <p className="text-stone-300 font-black text-sm">
                  ₹
                  {gstTotal.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingGst((v) => !v);
                  if (editingGst) setPendingGst(null);
                }}
                className="ml-1 p-1.5 rounded-lg hover:bg-white/10 text-stone-400 hover:text-amber-400 transition-colors"
                title="Edit GST rate for this category"
              >
                <Edit3 size={12} />
              </button>
            </div>
            <div className="p-2 text-stone-500">
              {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </div>
          </div>
        </div>

        {/* GST Editor */}
        <AnimatePresence>
          {editingGst && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mt-3 pt-3 border-t border-white/10 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className="text-[11px] font-bold text-stone-400 uppercase tracking-wider mr-1">
                    Apply to all "{category}" products:
                  </span>
                  {GST_RATES.map((r) => (
                    <GstPill
                      key={r}
                      rate={r}
                      active={(pendingGst ?? dominantGst) === r}
                      onClick={setPendingGst}
                    />
                  ))}
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setEditingGst(false);
                      setPendingGst(null);
                    }}
                    className="h-8 px-3 rounded-lg border border-white/10 text-stone-400 hover:text-white text-xs font-semibold transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleGstSave}
                    disabled={saving || pendingGst === null}
                    className="h-8 px-4 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-white font-black text-xs flex items-center gap-1.5 transition-all disabled:opacity-40"
                  >
                    {saving ? (
                      <RefreshCw size={11} className="animate-spin" />
                    ) : (
                      <Save size={11} />
                    )}
                    Apply to {products.length} products
                  </button>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* ── Expanded Product List ── */}
      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <div className="border-t border-white/10">
              {/* Product search + per-page selector */}
              <div className="px-5 py-3 border-b border-white/5 flex items-center gap-2">
                <div className="relative flex-1">
                  <Search
                    size={13}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-500"
                  />
                  <input
                    value={prodSearch}
                    onChange={(e) => {
                      setProdSearch(e.target.value);
                      setProdPage(1);
                    }}
                    placeholder="Search products in this category…"
                    className="w-full h-8 bg-white/5 border border-white/10 rounded-lg pl-8 pr-8 text-xs text-stone-300 outline-none focus:ring-1 focus:ring-amber-500/40 placeholder-stone-600 transition-all"
                  />
                  {prodSearch && (
                    <button
                      onClick={() => {
                        setProdSearch("");
                        setProdPage(1);
                      }}
                      className="absolute right-2.5 top-1/2 -translate-y-1/2 text-stone-500 hover:text-stone-300"
                    >
                      <X size={12} />
                    </button>
                  )}
                </div>
                {/* Per-page selector */}
                <select
                  value={prodPageSize}
                  onChange={(e) => {
                    setProdPageSize(Number(e.target.value));
                    setProdPage(1);
                  }}
                  className="h-8 px-2 rounded-lg border border-white/10 bg-white/5 text-stone-400 text-[11px] font-medium outline-none focus:ring-1 focus:ring-amber-500/40 shrink-0"
                >
                  {[5, 10, 20, 50, 100].map((n) => (
                    <option key={n} value={n} className="bg-[#1c1c2e]">
                      {n} / page
                    </option>
                  ))}
                </select>
              </div>

              {/* Product rows */}
              {pagedProds.length === 0 ? (
                <div className="px-5 py-8 text-center text-stone-500 text-sm">
                  No products match your search
                </div>
              ) : (
                <div className="divide-y divide-white/5">
                  {pagedProds.map((product, pi) => {
                    const rate = product.gst_rate ?? dominantGst;
                    const taxable = product.selling_price / (1 + rate / 100);
                    const gstPerUnit = product.selling_price - taxable;
                    const isLow =
                      product.stock_quantity > 0 &&
                      product.stock_quantity <= product.low_stock_threshold;
                    const isOut = product.stock_quantity === 0;
                    return (
                      <motion.div
                        key={product.id}
                        initial={{ opacity: 0, x: -6 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: pi * 0.02 }}
                        className="flex items-center gap-3 px-5 py-3 hover:bg-white/3 transition-colors group"
                      >
                        <img
                          src={`${process.env.REACT_APP_BACKEND_URL}${product.image_url}`}
                          alt={product.name}
                          className="w-10 h-10 object-cover rounded-xl flex-shrink-0 border border-white/10"
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-bold text-stone-200 truncate">
                            {product.name}
                          </p>
                          <p className="text-[10px] font-mono text-stone-600 mt-0.5">
                            {product.sku}
                          </p>
                        </div>
                        <div className="text-right flex-shrink-0 hidden sm:block">
                          <p className="font-mono font-black text-white text-sm">
                            ₹{product.selling_price.toFixed(2)}
                          </p>
                          <p className="text-[10px] text-stone-500">
                            taxable ₹{taxable.toFixed(2)}
                          </p>
                        </div>
                        <div className="text-right flex-shrink-0 min-w-[70px] hidden md:block">
                          <p className="text-[10px] text-stone-500 mb-0.5">
                            GST/unit
                          </p>
                          <p className="font-mono font-bold text-emerald-400 text-sm">
                            ₹{gstPerUnit.toFixed(2)}
                          </p>
                          <p className="text-[10px] text-stone-600">{rate}%</p>
                        </div>
                        <div className="flex items-center gap-2 flex-shrink-0">
                          <span
                            className={`text-[10px] font-black px-2 py-1 rounded-full border ${
                              isOut
                                ? "bg-rose-500/15 text-rose-400 border-rose-500/20"
                                : isLow
                                  ? "bg-amber-500/15 text-amber-400 border-amber-500/20"
                                  : "bg-white/8 text-stone-400 border-white/10"
                            }`}
                          >
                            {product.stock_quantity}
                          </span>
                          <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button
                              onClick={() => onProductQtyChange(product.id, -1)}
                              disabled={isOut}
                              className="w-6 h-6 rounded-lg bg-white/8 hover:bg-rose-500/20 text-stone-400 hover:text-rose-400 flex items-center justify-center transition-colors disabled:opacity-30"
                            >
                              <Minus size={10} />
                            </button>
                            <button
                              onClick={() => onProductQtyChange(product.id, 1)}
                              className="w-6 h-6 rounded-lg bg-white/8 hover:bg-emerald-500/20 text-stone-400 hover:text-emerald-400 flex items-center justify-center transition-colors"
                            >
                              <Plus size={10} />
                            </button>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </div>
              )}

              {/* Product-level pagination */}
              {totalProdPages > 1 && (
                <div className="px-5 py-3 border-t border-white/5 flex items-center justify-between">
                  <span className="text-[11px] text-stone-500">
                    {(prodPage - 1) * prodPageSize + 1}–
                    {Math.min(prodPage * prodPageSize, filteredProds.length)} of{" "}
                    {filteredProds.length} products
                  </span>
                  <div className="flex items-center gap-1">
                    <button
                      onClick={() => setProdPage(1)}
                      disabled={prodPage === 1}
                      className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
                    >
                      <ChevronsLeft size={12} />
                    </button>
                    <button
                      onClick={() => setProdPage((p) => Math.max(1, p - 1))}
                      disabled={prodPage === 1}
                      className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
                    >
                      <ChevronLeft size={12} />
                    </button>
                    {Array.from(
                      { length: Math.min(5, totalProdPages) },
                      (_, i) => {
                        const start = Math.max(
                          1,
                          Math.min(prodPage - 2, totalProdPages - 4),
                        );
                        const p = start + i;
                        return (
                          <button
                            key={p}
                            onClick={() => setProdPage(p)}
                            className={`w-7 h-7 rounded-lg text-xs font-semibold transition-all ${
                              p === prodPage
                                ? "bg-amber-500 text-white"
                                : "bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10"
                            }`}
                          >
                            {p}
                          </button>
                        );
                      },
                    )}
                    <button
                      onClick={() =>
                        setProdPage((p) => Math.min(totalProdPages, p + 1))
                      }
                      disabled={prodPage === totalProdPages}
                      className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
                    >
                      <ChevronRight size={12} />
                    </button>
                    <button
                      onClick={() => setProdPage(totalProdPages)}
                      disabled={prodPage === totalProdPages}
                      className="w-7 h-7 rounded-lg bg-white/5 border border-white/10 text-stone-400 hover:text-amber-400 hover:bg-white/10 disabled:opacity-30 flex items-center justify-center transition-all"
                    >
                      <ChevronsRight size={12} />
                    </button>
                  </div>
                </div>
              )}

              {/* Category GST Summary Footer */}
              <div className="px-5 py-3 bg-white/3 border-t border-white/10 flex items-center justify-between flex-wrap gap-3">
                <div className="flex items-center gap-4 flex-wrap">
                  {[
                    {
                      label: "Taxable Value",
                      value: `₹${products.reduce((s, p) => s + (p.selling_price / (1 + (p.gst_rate ?? dominantGst) / 100)) * p.stock_quantity, 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`,
                      color: "text-stone-300",
                    },
                    {
                      label: `GST @ ${displayGst}%`,
                      value: `₹${gstTotal.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`,
                      color: "text-emerald-400",
                    },
                    {
                      label: `CGST (${displayGst / 2}%) + SGST (${displayGst / 2}%)`,
                      value: `₹${(gstTotal / 2).toLocaleString("en-IN", { maximumFractionDigits: 2 })} each`,
                      color: "text-blue-400",
                    },
                  ].map((s) => (
                    <div key={s.label}>
                      <p className="text-[9px] text-stone-500 uppercase tracking-wider font-bold">
                        {s.label}
                      </p>
                      <p className={`text-sm font-black ${s.color}`}>
                        {s.value}
                      </p>
                    </div>
                  ))}
                </div>
                <div>
                  <p className="text-[9px] text-stone-500 uppercase tracking-wider font-bold">
                    Total MRP Value
                  </p>
                  <p className="text-sm font-black text-amber-400">
                    ₹
                    {stats.totalValue.toLocaleString("en-IN", {
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

// ═══════════════════════════════════════════════════════════════
// MAIN PAGE
// ═══════════════════════════════════════════════════════════════
const CategoryGST = () => {
  const { token } = useAuth();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [gstFilter, setGstFilter] = useState(null);

  // ── Category-level pagination ─────────────────────────────────
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const headers = useMemo(
    () => ({ Authorization: `Bearer ${token}` }),
    [token],
  );

  // ── Paginated batch fetch — avoids MongoDB cursor limits ──────
  const fetchProducts = useCallback(async () => {
    setLoading(true);
    setLoadingProgress(0);
    try {
      const BATCH = 500;
      let page = 1;
      let all = [];
      while (true) {
        const res = await axios.get(`${API_URL}/products`, {
          headers,
          params: { page, limit: BATCH },
        });
        const batch = res.data.products || [];
        const pagination = res.data.pagination || {};
        const totalPages = pagination.pages ?? 1;
        const total = pagination.total ?? batch.length;
        all = [...all, ...batch];
        // Update progress indicator
        setLoadingProgress(Math.round((all.length / Math.max(total, 1)) * 100));
        if (page >= totalPages || batch.length === 0) break;
        page++;
      }
      setProducts(all);
    } catch {
      toast.error("Failed to load products");
    } finally {
      setLoading(false);
      setLoadingProgress(100);
    }
  }, [headers]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // ── Reset to page 1 when filters change ──────────────────────
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, gstFilter, itemsPerPage]);

  // ── Group products by category ────────────────────────────────
  const grouped = useMemo(() => {
    const map = {};
    products.forEach((p) => {
      const cat = p.category || "Uncategorized";
      if (!map[cat]) map[cat] = [];
      map[cat].push(p);
    });
    return map;
  }, [products]);

  // ── Filter + sort all categories ─────────────────────────────
  const allFilteredCategories = useMemo(() => {
    return Object.entries(grouped)
      .filter(([cat, prods]) => {
        const matchSearch =
          !searchQuery ||
          cat.toLowerCase().includes(searchQuery.toLowerCase()) ||
          prods.some(
            (p) =>
              p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              p.sku?.toLowerCase().includes(searchQuery.toLowerCase()),
          );
        const matchGst =
          gstFilter === null ||
          prods.some((p) => (p.gst_rate ?? 18) === gstFilter);
        return matchSearch && matchGst;
      })
      .sort((a, b) => a[0].localeCompare(b[0]));
  }, [grouped, searchQuery, gstFilter]);

  // ── Paginate categories ───────────────────────────────────────
  const totalPages = Math.ceil(allFilteredCategories.length / itemsPerPage);
  const pagedCategories = allFilteredCategories.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // ── Overall summary ────────────────────────────────────────────
  const summary = useMemo(() => {
    const totalGSTValue = products.reduce((s, p) => {
      const r = p.gst_rate ?? 18;
      return (
        s +
        (p.selling_price - p.selling_price / (1 + r / 100)) * p.stock_quantity
      );
    }, 0);
    const totalMRP = products.reduce(
      (s, p) => s + p.selling_price * p.stock_quantity,
      0,
    );
    const byRate = {};
    products.forEach((p) => {
      const r = p.gst_rate ?? 18;
      const gst =
        (p.selling_price - p.selling_price / (1 + r / 100)) * p.stock_quantity;
      byRate[r] = (byRate[r] || 0) + gst;
    });
    return {
      totalCategories: Object.keys(grouped).length,
      totalProducts: products.length,
      totalGSTValue,
      totalMRP,
      totalTaxable: totalMRP - totalGSTValue,
      byRate,
    };
  }, [products, grouped]);

  // ── Handlers ──────────────────────────────────────────────────
  const handleGstChange = useCallback(
    async (category, prods, newRate) => {
      // Update in batches to avoid overwhelming the server
      const BATCH = 10;
      for (let i = 0; i < prods.length; i += BATCH) {
        const slice = prods.slice(i, i + BATCH);
        await Promise.all(
          slice.map((p) =>
            axios.put(
              `${API_URL}/products/${p.id}`,
              { gst_rate: newRate },
              { headers },
            ),
          ),
        );
      }
      setProducts((prev) =>
        prev.map((p) =>
          p.category === category ? { ...p, gst_rate: newRate } : p,
        ),
      );
    },
    [headers],
  );

  const handleProductQtyChange = useCallback(
    async (productId, delta) => {
      const product = products.find((p) => p.id === productId);
      if (!product) return;
      const newQty = Math.max(0, product.stock_quantity + delta);
      try {
        await axios.put(
          `${API_URL}/products/${productId}`,
          { stock_quantity: newQty },
          { headers },
        );
        setProducts((prev) =>
          prev.map((p) =>
            p.id === productId ? { ...p, stock_quantity: newQty } : p,
          ),
        );
      } catch {
        toast.error("Failed to update quantity");
      }
    },
    [products, headers],
  );

  // ─────────────────────────────────────────────────────────────
  return (
    <div
      className="min-h-full bg-[#f7f6f3] p-4 md:p-6 lg:p-8"
      data-testid="category-gst-page"
    >
      {/* ── Hero Header ── */}
      <motion.div
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative overflow-hidden bg-[#1c1c2e] rounded-2xl p-6 mb-6 shadow-xl"
      >
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 80% 40%, #10b981 0%, transparent 50%), radial-gradient(circle at 15% 80%, #f59e0b 0%, transparent 40%)",
          }}
        />
        <div className="relative flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-emerald-500/15 rounded-2xl border border-emerald-500/20">
              <Layers size={24} className="text-emerald-400" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-black text-white tracking-tight">
                Category GST Manager
              </h1>
              <p className="text-stone-400 text-sm mt-0.5">
                View and bulk-update GST rates by product category
              </p>
            </div>
          </div>
          <button
            onClick={fetchProducts}
            disabled={loading}
            className="flex items-center gap-2 bg-white/10 hover:bg-white/15 border border-white/15 text-stone-300 hover:text-white font-bold text-sm px-4 py-3 rounded-xl transition-all"
          >
            <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
            Refresh
          </button>
        </div>

        {/* Summary stats */}
        <div className="relative mt-5 pt-4 border-t border-white/10 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            {
              label: "Categories",
              value: summary.totalCategories,
              color: "text-amber-400",
            },
            {
              label: "Total Products",
              value: summary.totalProducts,
              color: "text-stone-200",
            },
            {
              label: "Taxable Value",
              value: `₹${summary.totalTaxable.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
              color: "text-blue-400",
            },
            {
              label: "Total GST",
              value: `₹${summary.totalGSTValue.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
              color: "text-emerald-400",
            },
          ].map((s) => (
            <div key={s.label}>
              <p className="text-stone-500 text-[10px] uppercase tracking-wider font-semibold mb-0.5">
                {s.label}
              </p>
              <p className={`font-mono font-black text-lg ${s.color}`}>
                {s.value}
              </p>
            </div>
          ))}
        </div>

        {/* GST rate filter chips */}
        {Object.keys(summary.byRate).length > 0 && (
          <div className="relative mt-4 pt-3 border-t border-white/10 flex flex-wrap gap-2 items-center">
            <span className="text-[10px] text-stone-500 font-bold uppercase tracking-wider">
              Filter by rate:
            </span>
            {Object.entries(summary.byRate)
              .sort((a, b) => Number(a[0]) - Number(b[0]))
              .map(([rate, val]) => (
                <button
                  key={rate}
                  onClick={() =>
                    setGstFilter((prev) =>
                      prev === Number(rate) ? null : Number(rate),
                    )
                  }
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[11px] font-bold border transition-all ${
                    gstFilter === Number(rate)
                      ? "bg-emerald-500/20 border-emerald-500/50 text-emerald-300"
                      : "bg-white/5 border-white/10 text-stone-400 hover:border-white/25 hover:text-stone-200"
                  }`}
                >
                  <span className="text-emerald-400">{rate}%</span>
                  <span className="text-stone-600">→</span>
                  <span>
                    ₹{val.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </span>
                </button>
              ))}
            {gstFilter !== null && (
              <button
                onClick={() => setGstFilter(null)}
                className="flex items-center gap-1 px-2.5 py-1.5 rounded-xl text-[11px] font-bold bg-rose-500/15 border border-rose-500/30 text-rose-400 hover:bg-rose-500/25 transition-all"
              >
                <X size={10} /> Clear
              </button>
            )}
          </div>
        )}
      </motion.div>

      {/* ── Search ── */}
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="relative mb-5"
      >
        <Search
          size={15}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search categories or products…"
          className="w-full h-11 bg-white border border-stone-200 rounded-xl pl-10 pr-4 text-sm text-stone-700 outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-400/50 shadow-sm"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-600 p-1"
          >
            <X size={13} />
          </button>
        )}
      </motion.div>

      {/* ── Content ── */}
      {loading ? (
        <div className="flex items-center justify-center py-24">
          <div className="text-center">
            <div className="relative w-14 h-14 mx-auto mb-4">
              <div className="absolute inset-0 rounded-full border-4 border-emerald-100" />
              <div className="absolute inset-0 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin" />
            </div>
            <p className="text-stone-400 text-sm">Loading categories…</p>
            {loadingProgress > 0 && loadingProgress < 100 && (
              <p className="text-stone-500 text-xs mt-1">
                {loadingProgress}% loaded
              </p>
            )}
          </div>
        </div>
      ) : allFilteredCategories.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 bg-white rounded-2xl border border-stone-100 shadow-sm">
          <div className="p-4 bg-stone-100 rounded-2xl mb-4">
            <Layers size={32} className="text-stone-300" />
          </div>
          <p className="text-stone-500 font-semibold">No categories found</p>
          <p className="text-stone-400 text-sm mt-1">
            {searchQuery
              ? "Try adjusting your search"
              : "Add products to see categories"}
          </p>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15 }}
        >
          <div className="space-y-3">
            {pagedCategories.map(([category, prods], idx) => (
              <CategoryCard
                key={category}
                category={category}
                products={prods}
                onGstChange={handleGstChange}
                onProductQtyChange={handleProductQtyChange}
                index={idx}
              />
            ))}
          </div>

          {/* ── Category Pagination ── */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={allFilteredCategories.length}
            itemsPerPage={itemsPerPage}
            onPageChange={setCurrentPage}
            onPerPageChange={(n) => {
              setItemsPerPage(n);
              setCurrentPage(1);
            }}
          />
        </motion.div>
      )}
    </div>
  );
};

export default CategoryGST;
